import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PriceListLine } from 'src/app/assabil-kernel/models/entities/master-data/price-list-line-entity';
import { PriceList } from 'src/app/assabil-kernel/models/entities/master-data/price-list-entity';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Field } from 'src/app/tools/models/dtos/field';
import { PriceListLineDetail } from 'src/app/assabil-kernel/models/entities/master-data/price-list-line-detail-entity';


@Component({
  selector: 'price-list-widget',
  templateUrl: './price-list-widget.component.html',
  styleUrls: ['./price-list-widget.component.scss']
})

export class PriceListWidgetComponent extends BaseWidget {


  @Input() priceListLineFields        : Field[];
  @Input() priceListLineDetailFields  : Field[];

  priceList     : PriceList     = new PriceList();
  priceListLine : PriceListLine;

  //-----------------------------------------------------------------------------------------------------------------------------
  constructor(
      protected masterDataService   : MasterDataService, 
        protected toastr            : ToastrService,
        protected leanUtilsService  : LeanUtilsService) {
          super(toastr, leanUtilsService);
    }
  //-----------------------------------------------------------------------------------------------------------------------------


  //-----------------------------------------------------------------------------------------------------------------------------
  setEntity(priceList: PriceList) {
    this.priceList  = { ...priceList };
    this.priceList.priceListLines = [];
    if (priceList.priceListLines) {
      for (let priceListLine of priceList.priceListLines) {
        let priceListLine2 =  {...priceListLine }
        priceListLine2.priceListLineDetails = [];
        for (let priceListLineDetail of priceListLine.priceListLineDetails) {
          priceListLine2.priceListLineDetails.push({...priceListLineDetail});
        }
        this.priceList.priceListLines.push(priceListLine2);
      }
    }
    if (this.priceList.priceListLines) this.priceListLine = this.priceList.priceListLines[0];
  }
  //-----------------------------------------------------------------------------------------------------------------------------

  //-----------------------------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.priceList;
  }
  //-----------------------------------------------------------------------------------------------------------------------------

    
  //-----------------------------------------------------------------------------------------------------------------------------
  saveRow() : Promise<PriceList>{
    return  this.masterDataService.priceListSave(this.priceList);
  }
  //-----------------------------------------------------------------------------------------------------------------------------


  //-----------------------------------------------------------------------------------------------------------------------------
  newPriceListLine(){
    let priceListLine = new PriceListLine();
    priceListLine.inserted = true;
    priceListLine.edit     = true;
    this.priceList.priceListLines.push(priceListLine);
    this.priceList.priceListLines = [... this.priceList.priceListLines]
  }
  //-----------------------------------------------------------------------------------------------------------------------------

  
  //-----------------------------------------------------------------------------------------------------------------------------
  newPriceListLineDetail(){
    let priceListLineDetail = new PriceListLineDetail();
    priceListLineDetail.inserted = true;
    priceListLineDetail.edit     = true;
    this.priceListLine.priceListLineDetails.push(priceListLineDetail);
    this.priceListLine.priceListLineDetails = [... this.priceListLine.priceListLineDetails]
  }
  //-----------------------------------------------------------------------------------------------------------------------------

}
